export const normalizeEmail = (value) => String(value || "").trim().toLowerCase();
